module.exports = __webpack_public_path__ + "img/benefits-empty-image.0c4e3165.png";